import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

// import Typography from '@mui/material/Typography';
// import { ReactComponent as Lepton } from '../logo.svg'
import ReactSVG from "react-svg";
import ReactDOM from "react-dom";

import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { ConnectWallet } from "@thirdweb-dev/react";



import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

import SearchIcon from '@mui/icons-material/Search';
import RegistrationDialog from './RegistrationDialog';
import {ButtonGroup, Icon} from "@mui/material";
import LogInDialog from "./LogInDialog";
import {green} from "@mui/material/colors";


const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  }));

  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));
  
  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
  }));

export default function MenuBar() {
  const col = green[900];
  // handle registration
  const [registerOpen, setRegisterOpen] = React.useState(false);
  const [loginOpen, setLoginOpen] = React.useState(false);
  const handleRegisterOpen = () => {
    setRegisterOpen(true);
  }
  const handleRegisterClose = () => {
    setRegisterOpen(false);
  }
  const handleLoginOpen = () => {
      setLoginOpen(true);
  }
  const handleLoginClose = () => {
      setLoginOpen(false);
  }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="fixed">
                <Toolbar sx={{ bgcolor: `rgb(32, 32, 48)`}}>
                    {/*<LibraryMusicIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />*/}
                    {/* <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        YueTong
                    </Typography> */}

                    {/*<Icon>*/}
                    {/*<img src={'../../public/logo192.png'}/>*/}
                    {/*</Icon>*/}
                    {/*<Button color="inherit" component={Link} to="/" sx={{ flexGrow: 1 }}>*/}
                    {/*        Lepton*/}
                    {/*</Button>*/}

                    <Button color="inherit" component={Link} to="/" sx={{ flexGrow: 1 }}><img src={require("../images/newlogo.png")}
                                                                                              width={'50px'} height={'50px'}/>Lepton</Button>

                    <Search>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ 'aria-label': 'search' }}
                        />
                    </Search>
                    {/* <Button color="inherit" component={Link} to="/">Home</Button> */}
                    <Button color="inherit" component={Link} to="all-musics">Explore</Button>
                    <Button color="inherit" component={Link} to="community">Community</Button>
                    {/*<Button color="inherit" component={Link} to="brand">OurBrand</Button>*/}
                    <Button color="inherit" component={Link} to="music-upload">UploadMusic</Button>
                    {/*<Button color='inherit' onClick={handleRegisterOpen}>Registration/Login</Button>*/}
                    <ButtonGroup
                        disableElevation
                        variant="text"
                        color="inherit"
                        aria-label="Disabled elevation buttons"
                    >
                        <Button  onClick={handleRegisterOpen}>Registration</Button>
                        <Button onClick={handleLoginOpen}>Login</Button>
                        <ConnectWallet/>
                    </ButtonGroup>
                    {/* <IconButton aria-label="account">
                        <AccountCircleIcon />
                    </IconButton>
                    <IconButton aria-label="wallet">
                        <AccountBalanceWalletIcon />
                    </IconButton>
                    <IconButton aria-label="cart">
                        <ShoppingCartIcon />
                    </IconButton> */}



                </Toolbar>
            </AppBar>
            <RegistrationDialog open={registerOpen} handleClose={handleRegisterClose}/>
            <LogInDialog open={loginOpen} handleClose={handleLoginClose}/>
        </Box>
    );
}